import { Destination, DestinationList } from 'types/stream';

const getDestinationsByNetwork = (list: DestinationList, network: Destination, selectedIds: string[]) => {
  const destinationsList = list.filter(d => d.network === network);

  const mappedList = destinationsList.map(d => ({ ...d, isChecked: selectedIds.includes(d.id) }));

  return mappedList;
};

export default getDestinationsByNetwork;
